'server-only';

/**
 * Các key headers sẽ được sử dụng ở nội bộ server của nextjs
 */
export const NEXT_HEADERS_KEY = {
    /**
     * Lưu token trong headers của next servers
     */
    Token: 'x-authentication-token',

    /**Lưu thông tin role được lấy từ token trả về của API */
    Role: 'x-account-role',
    /**
     * Target hiện tại của token đang muốn login ở đâu
     * Ví dụ đang sử dụng tài khoản cán bộ nhưng target sử dụng là customer chẳng hạnhạn
     */
    Target: 'x-account-target',

    /**
     * Lưu thông tin API key để xác thực với server
     */
    ApiKey: 'x-api-key',
};

/**
 * Các key headers sẽ được sử dụng gửi cho server API
 */
export const API_HEADERS_KEY = {
    /** */
    ApiKey: 'ApiKey',
    /** */
    Accept: 'Accept',
    /** */
    Accept_Encoding: 'Accept-Encoding',
    /** */
    Accept_Language: 'Accept-Language',
    /** */
    User_Agent: 'User-Agent',
    /** */
    Content_Type: 'Content-Type',
    /** */
    Origin: 'Origin',
    /** */
    Referer: 'Referer',
    /** */
    Authorization: 'Authorization',

    /**
     * Sử dụng cho gửi kèm data trong headerss
     */
    HeaderName_Tatic: 'tat1c',
    /**
     * Sử dụng cho gửi kèm data trong headerss
     */
    HeaderName_AutoEmail: '3ma1l',
    /**
     * Sử dụng cho gửi kèm data trong headerss
     */
    HeaderName_OTPValue: '0tp',
};

/**
 * Các status code mà server trả về là thành công
 */
export const HTTP_SUCCESS_STATUS_CODES = [200, 201, 202, 204];

/**
 * Các status code mà server trả về là lỗi
 */
export const HTTP_FAILED_STATUS_CODES = [
    400, 401, 403, 404, 405, 500, 502, 503, 504,
];

/**
 * Các key sẽ được sử dụng trong ASP.NET
 */
export const CLAIMS_KEY = {
    UserId: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    UserName: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
    Email: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
    Role: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
    GivenName:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
    Surname: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
    DateOfBirth:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dateofbirth',
    StreetAddress:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/streetaddress',
    Locality: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality',
    StateOrProvince:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/stateorprovince',
    PostalCode:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/postalcode',
    Country: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country',
    MobilePhone:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone',
    HomePhone:
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/homephone',
    Gender: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/gender',
    Website: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/webpage',
};

/**
 * Text thông báo lỗi của nextjs
 */
export const NEXT_ERROR_DIRECTORIES = {
    [400]: '#400 - Bad Request',
    [401]: '#401 - Unauthorized',
    [403]: '#403 - Forbidden',
    [404]: '#404 - Not Found',
    [405]: '#405 - Method Not Allowed',
    [406]: '#406 - Not Acceptable',
    [407]: '#407 - Proxy Authentication Required',
    [408]: '#408 - Request Timeout',
    [409]: '#409 - Conflict',
    [410]: '#410 - Gone',
    [411]: '#411 - Length Required',
    [412]: '#412 - Precondition Failed',
    [413]: '#413 - Payload Too Large',
    [414]: '#414 - URI Too Long',
    [415]: '#415 - Unsupported Media Type',
    [416]: '#416 - Range Not Satisfiable',
    [417]: '#417 - Expectation Failed',
    [418]: "#418 - I'm a teapot",
    [421]: '#421 - Misdirected Request',
    [422]: '#422 - Unprocessable Entity',
    [423]: '#423 - Locked',
    [424]: '#424 - Failed Dependency',
    [425]: '#425 - Too Early',
    [426]: '#426 - Upgrade Required',
    [428]: '#428 - Precondition Required',
    [429]: '#429 - Too Many Requests',
    [431]: '#431 - Request Header Fields Too Large',
    [451]: '#451 - Unavailable For Legal Reasons',
    [500]: '#500 - Internal Server Error',
    [501]: '#501 - Not Implemented',
    [502]: '#502 - Bad Gateway',
    [503]: '#503 - Service Unavailable',
    [504]: '#504 - Gateway Timeout',
    [505]: '#505 - HTTP Version Not Supported',
    [506]: '#506 - Variant Also Negotiates',
    [507]: '#507 - Insufficient Storage',
    [508]: '#508 - Loop Detected',
    [510]: '#510 - Not Extended',
    [511]: '#511 - Network Authentication Required',
};
